// extracted by mini-css-extract-plugin
module.exports = {"container":"container-drag_container__C4V9g","isDragging":"container-drag_isDragging__YXxlw"};